import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/project_nav_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "addproduct",
  data: function data() {
    return {
      form: {
        id: "",
        name: "",
        icon: "",
        status: 1,
        sort: 0,
        environments: [],
        description: ''
      },
      dialogShow: false,
      fileList: [],
      environmentsList: [],
      rules: {
        sort: [{
          required: true,
          message: "请输入排序",
          trigger: "blur"
        }],
        name: [{
          required: true,
          message: "请输入名称",
          trigger: "blur"
        }],
        env_id: [{
          required: true,
          message: "请选择环境",
          trigger: "blur"
        }],
        url: [{
          required: true,
          message: "请输入链接",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.getEnvirList();

                if (data) {
                  _this.form = {
                    id: data.id,
                    name: data.name,
                    icon: data.icon,
                    status: data.status,
                    sort: data.sort,
                    environments: data.environments,
                    description: data.description
                  };
                  _this.fileList = data.icon ? [data.icon] : [];
                }

                _this.dialogShow = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getEnvirList: function getEnvirList() {
      var _this2 = this;

      this.$api.environments().then(function (res) {
        if (res.code == 200) {
          _this2.environmentsList = res.data;
        }
      });
    },
    addDomain: function addDomain() {
      this.form.environments.push({
        env_id: '',
        url: '',
        status: 1,
        description: '',
        sort: this.form.environments.length
      });
    },
    removeDomain: function removeDomain(item) {
      var index = this.form.environments.indexOf(item);

      if (index !== -1) {
        this.form.environments.splice(index, 1);
      }
    },
    imgChange: function imgChange(e) {
      console.log("e===", e);
      this.fileList = e;
      this.form.icon = e[0] && e[0].response ? e[0].response.data : '';
      console.log("this.form.icon", e);
    },
    urlChange: function urlChange(e) {},
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = {
        id: "",
        name: "",
        icon: "",
        status: 1,
        sort: "",
        environments: [],
        description: ''
      };
      this.fileList = [];
      this.$refs.ruleForm.resetFields();
    },
    hide: function hide() {
      this.dialogShow = false;
    },
    submitData: function submitData() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this3.form.id ? 'productsUpdate' : 'productsCreate';

          _this3.$api[reqFn](_this3.form).then(function (res) {
            if (res.code == 200) {
              _this3.$message({
                message: '操作成功',
                type: 'success'
              });

              _this3.hide();

              _this3.$emit('change');
            }
          });
        }
      });
    }
  }
};